import { render, staticRenderFns } from "./ticketDialog.vue?vue&type=template&id=35cb0a9a&"
import script from "./ticketDialog.vue?vue&type=script&lang=js&"
export * from "./ticketDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports